const productTypeToAliasMap = {
  exchange: 'exchange',
  repairs: 'repair',
  returns: 'returns',
  return: 'return',
};

const productAliasToTypeMap = {
  repair: 'repairs',
  returns: 'returns',
};

export const getProductTypeFromAlias = (alias) => productAliasToTypeMap[alias] || 'returns';

export const getProductAliasFromType = (productType) =>
  productTypeToAliasMap[productType] || 'returns';

export const getProductTypeFromURL = (url) => {
  const { pathname } = new URL(url);
  const product = pathname.split('/').pop();
  const productAlias = product === 'repair' ? 'repair' : 'returns';
  return getProductTypeFromAlias(productAlias);
};
